var accountancy = {
	data () {
		return {
			listPeriods: [
				{ year: 2020, month: '01', open:false},
				{ year: 2020, month: '02', open:false},
				{ year: 2020, month: '03', open:false},
				{ year: 2020, month: '04', open:false},
				{ year: 2020, month: '05', open:false},
				{ year: 2020, month: '06', open:false},
				{ year: 2020, month: '07', open:false},
				{ year: 2020, month: '08', open:false},
				{ year: 2020, month: '09', open:false},
				{ year: 2020, month: '10', open:false},
				{ year: 2020, month: '11', open:false},
				{ year: 2020, month: '12', open:false},
				{ year: 2021, month: '01', open:false},
				{ year: 2021, month: '02', open:false},
				{ year: 2021, month: '03', open:false},
				{ year: 2021, month: '04', open:true},
				{ year: 2021, month: '05', open:true},
				{ year: 2021, month: '06', open:true},
				{ year: 2021, month: '07', open:true},
				{ year: 2021, month: '08', open:true},
				{ year: 2021, month: '09', open:true},
				{ year: 2021, month: '10', open:true},
				{ year: 2021, month: '11', open:true},
				{ year: 2021, month: '12', open:true},
			]
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
	},
};

export default accountancy;